// src/components/layout/Header.tsx
import React from 'react'
import { Button } from '../ui/button'
import { Plus, ChevronRight } from 'lucide-react'
import NotificationBell from './NotificationBell'

interface HeaderProps {
  activeTab: string;
  onCreateOrder: () => void;
}

export default function Header({ activeTab, onCreateOrder }: HeaderProps) {
  const getTabTitle = (tab: string) => {
    switch (tab) {
      case 'dashboard':
        return 'Kontrol Paneli'
      case 'payments':
        return 'Ödemeler'
      case 'orders':
        return 'Siparişler'
      case 'earnings':
        return 'Kazançlar'
      case 'profile':
        return 'Profil'
      case 'settings':
        return 'Ayarlar'
      case 'notifications':
        return 'Sistem Mesajları'
      default:
        return 'Kontrol Paneli'
    }
  }

  const getTabDescription = (tab: string) => {
    switch (tab) {
      case 'dashboard':
        return 'Amazon siparişlerinizi takip edin ve bonuslarınızı görün'
      case 'payments':
        return 'Ödeme geçmişinizi görüntüleyin ve ödeme yöntemlerinizi yönetin'
      case 'orders':
        return 'Sipariş detaylarınızı görüntüleyin ve yönetin'
      case 'profile':
        return 'Profil bilgilerinizi görüntüleyin ve güncelleyin'
      case 'settings':
        return 'Hesap ayarlarınızı yönetin'
      case 'notifications':
        return 'Size gönderilen tüm sistem mesajları'
      default:
        return 'Amazon siparişlerinizi takip edin ve bonuslarınızı görün'
    }
  }

  const getTabLabel = (tab: string) => {
    switch (tab) {
      case 'payments':
        return 'Ödemeler'
      case 'orders':
        return 'Siparişler'
      case 'profile':
        return 'Profil'
      case 'settings':
        return 'Ayarlar'
      case 'notifications':
        return 'Sistem Mesajları'
      default:
        return ''
    }
  }

  return (
    <header className="glass border-b border-orange-200 p-6 relative z-50">
      <div className="flex items-center justify-between">
        <div>
          {/* Breadcrumb */}
          <div className="flex items-center text-sm text-gray-600 mb-2">
            <span>Kontrol Paneli</span>
            {activeTab !== 'dashboard' && (
              <>
                <ChevronRight className="w-4 h-4 mx-2" />
                <span className="text-orange-600 capitalize">
                  {getTabLabel(activeTab)}
                </span>
              </>
            )}
          </div>
          <h2 className="text-2xl font-bold text-gray-800">
            {getTabTitle(activeTab)}
          </h2>
          <p className="text-gray-600">
            {getTabDescription(activeTab)}
          </p>
        </div>

        <div className="flex items-center space-x-4">
          <NotificationBell />
<Button
  className="bg-orange-500 hover:bg-orange-600 text-white"
  onClick={() => {
    window.open("https://www.amazon.com/?EBH=morder", "_blank");
  }}
>
  <Plus className="w-4 h-4 mr-2" />
  Manuel Sipariş - FBA Sipariş
</Button>


        </div>
      </div>
    </header>
  )
}